var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/12214d6ab73d059c313539cb8d88ef9c.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6bbdd1ea94ea1285f2dd9ecd508fa767.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    